import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useAdditionalPropertyValues } from '../../v2/hooks/useAdditionalPropertyValues';
import { useHomeCurrency } from '../../v2/hooks/useHomeCurrency';
import { useObjectTypeId } from '../../v2/hooks/useObjectTypeId';
import { useProperty } from '../../v2/hooks/useProperty';
import { getEffectiveTieredPriceCurrencyCode } from '../../utils/currency';
import { TieredPriceModalContainer } from './modal/TieredPriceModalContainer';
import { TieredPriceModalFooter } from './modal/TieredPriceModalFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceModal = ({
  onEdit,
  onSave,
  onClose
}) => {
  const objectTypeId = useObjectTypeId();
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    name: 'name',
    lineItemCurrencyCode: 'hs_line_item_currency_code'
  });
  const objectName = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.name;
  const property = useProperty();
  const {
    data: homeCurrencyCode
  } = useHomeCurrency();
  const currencyCode = useMemo(() => {
    return getEffectiveTieredPriceCurrencyCode(objectTypeId, property, homeCurrencyCode, additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.lineItemCurrencyCode);
  }, [objectTypeId, property, homeCurrencyCode, additionalValues]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "tiered-pricing-modal",
    width: 644,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      "data-test-id": "tiered-price-modal-header",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.tieredPricing.modal.title",
          options: {
            name: objectName
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "tiered-price-modal-close-btn",
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(TieredPriceModalContainer, {
        currencyCode: currencyCode
      })
    }), /*#__PURE__*/_jsx(TieredPriceModalFooter, {
      onSave: onSave,
      onEdit: onEdit,
      onClose: onClose
    })]
  });
};